module.exports = __webpack_public_path__ + "0802ddc2e582bfd97fd9fcc036ca2b2a.svg";